import { Instance, types } from 'mobx-state-tree'

export enum MetricUnit {
    KILOGRAMS = 'kilograms',
    METERS = 'meters'
}

export enum MeasurementUnitsEnum {
    Metric = 'metric',
    Imperial = 'imperial',
}

export const measurementUnitsValues = Object.values(MeasurementUnitsEnum)  

const FEET_IN_METERS = 3.28084
const METERS = 'meters'
const KNOWN_METRIC_UNITS = [METERS]

export const MeasurementUnitsModel = types.model('MeasurementUnitModel', {
  measurementUnit: types.enumeration('MeasurementUnits', measurementUnitsValues)
})
.views((self) => ({
  get distanceShortUnitName() {
    switch(self.measurementUnit) {
        case MeasurementUnitsEnum.Metric:
            return 'm'
        case MeasurementUnitsEnum.Imperial:
            return 'ft'
        default:
            throw Error(`Unsupported measurement unit system`)
    }
  },
  getMeasurementUnitName(metricUnitName: string): string {
    if (!KNOWN_METRIC_UNITS.includes(metricUnitName)) {
        throw Error(`Unsupported measurement unit ${metricUnitName}`)
    }
    switch (self.measurementUnit) {
        case MeasurementUnitsEnum.Metric:
            return metricUnitName
        case MeasurementUnitsEnum.Imperial:
            if (metricUnitName === METERS) {
                return 'feet'
            } 
            throw Error(`Unsupported measurement unit ${metricUnitName}`)
        default:
            throw Error(`Unsupported measurement unit system`)
    }
  },
  convertFromMetric(value: number, units: string): number {
    if (!KNOWN_METRIC_UNITS.includes(units)) {
        throw Error(`Unsupported measurement unit ${units}`)
    }
    switch (self.measurementUnit) {
        case MeasurementUnitsEnum.Metric:
            return value
        case MeasurementUnitsEnum.Imperial:
            if (units === METERS) {
                return value * FEET_IN_METERS
            } 
            throw Error(`Unsupported measurement unit for conversion ${units}`)
        default: 
            throw Error(`Unsupported measurement unit system`)
    }
  },
}))
.views((self) => ({
    formatDistanceFromMeters(distanceInMeters: number, precision: number): string {
        const convertedValue = self.convertFromMetric(distanceInMeters, METERS)
        const formattedValueNoTrailingZeros = Number(convertedValue.toFixed(precision)).toString()
        return formattedValueNoTrailingZeros
    },
    convertDistanceToMeters(distanceInCenterMeasurementUnit: number): number {
        if (self.measurementUnit === MeasurementUnitsEnum.Metric) {
            return distanceInCenterMeasurementUnit
        } else {
            return distanceInCenterMeasurementUnit / FEET_IN_METERS
        }
    }
}))

export const MeasurementUnitInstances = {
  [MeasurementUnitsEnum.Metric]: MeasurementUnitsModel.create({ measurementUnit: MeasurementUnitsEnum.Metric }),
  [MeasurementUnitsEnum.Imperial]: MeasurementUnitsModel.create({ measurementUnit: MeasurementUnitsEnum.Imperial }) 
}

export type MeasurementUnits = Instance<typeof MeasurementUnitsModel>